import { errorMessage } from '../../../../error-message.js';
import type { LogFn } from '../../../../log.js';

type SendSessionUpdate = (payload: unknown) => void;

function extractSessionInfoTitle(params: unknown): string | null {
  if (!params || typeof params !== 'object') return null;
  const p = params as Record<string, unknown>;
  const title = typeof p.title === 'string' ? p.title.trim() : '';
  return title ? title : null;
}

export function sendSessionInfoTitleUpdate(params: {
  payload: unknown;
  runId: string | undefined;
  sessionId: string | undefined;
  send: SendSessionUpdate | undefined;
  log: LogFn;
}): void {
  const title = extractSessionInfoTitle(params.payload);
  if (!title || !params.runId || !params.send) return;

  try {
    params.send({
      type: 'session_title_update',
      ...(params.sessionId ? { sessionId: params.sessionId } : {}),
      runId: params.runId,
      title,
    });
  } catch (err) {
    params.log(`[Bridge service] Session title update send failed: ${errorMessage(err)}`);
  }
}
